Namespace 'Common.Dashboard.Filters'

Common.Dashboard.Filters.FixedStringFiltersMixin =
  _getSelectedValues: ->
    $.extend({}, @filter._valuesToJSON(), @lastAppliedFilter)
